import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Coins, Mail } from "lucide-react";
import { http, errMsg } from "../../lib/api";
import { Input } from "../ui/input";

export const CreditCard = () => {
  const [s, setS] = useState(null);
  const [amt, setAmt] = useState("");
  const load = () => http.get("/settings/credit").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);
  const save = async (mode) => {
    const amount = parseFloat(amt);
    if (!(amount > 0)) return toast.error("Enter the dollar amount");
    try { const { data } = await http.post("/settings/credit", { amount, mode }); setS(data); setAmt(""); toast.success(`Credit recorded — ≈ ${data.kits_left} kits left`); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const test = () => http.post("/settings/credit/test-alert").then(() => toast.success("Test alert sent to your admin email")).catch((e) => toast.error(errMsg(e)));
  if (!s) return null;
  const low = s.tracking && s.kits_left <= 2;
  return (
    <div data-testid="credit-card" className={`rounded-xl border bg-white p-5 mb-6 flex flex-wrap items-center gap-5 ${low ? "border-amber-400" : "border-stone-200"}`}>
      <div className="min-w-[220px]">
        <div className="eyebrow flex items-center gap-2"><Coins size={12} /> OpenRouter credit (estimated)</div>
        <div data-testid="credit-billing" className="text-[11px] text-stone-400">Writing & web research billed to your OpenRouter key · cover images on the Universal Key</div>
        {s.tracking ? (
          <div className="mt-1">
            <span data-testid="credit-remaining" className={`font-display text-3xl ${low ? "text-amber-600" : ""}`}>${Math.max(s.remaining, 0).toFixed(2)}</span>
            <span data-testid="credit-kits-left" className="ml-3 text-sm text-stone-500">≈ {s.kits_left} kit{s.kits_left === 1 ? "" : "s"} left · a kit ≈ ${s.avg_kit.toFixed(2)}</span>
          </div>
        ) : <p data-testid="credit-not-tracking" className="text-sm text-stone-500 mt-1">Enter your OpenRouter (openrouter.ai → Credits) balance to get low-credit warnings.</p>}
      </div>
      <div className="flex flex-wrap items-center gap-2 ml-auto">
        <span className="text-sm text-stone-500">$</span>
        <Input data-testid="credit-amount-input" type="number" min="0" step="1" value={amt} onChange={(e) => setAmt(e.target.value)} placeholder="Amount" className="h-10 w-28 bg-[#F7F5F0]" />
        <button data-testid="credit-add-button" onClick={() => save("add")} className="rounded-sm bg-[#2B2A26] px-4 py-2 text-sm font-bold text-white">I added this</button>
        <button data-testid="credit-set-button" onClick={() => save("set")} className="rounded-sm border border-stone-300 px-4 py-2 text-sm hover:bg-stone-100">My balance is this</button>
        <button data-testid="credit-test-alert" onClick={test} title="Send a test alert email" className="rounded-sm border border-stone-300 p-2.5 hover:bg-stone-100"><Mail size={14} /></button>
      </div>
      <p className="w-full text-[11px] text-stone-400 -mt-2">Estimated from the AI usage of each build. You get an email at ≈ 2 kits and ≈ 1 kit left, and the queue pauses on its own before a kit it can’t finish.</p>
    </div>
  );
};
